import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

/**
 * Inter Labs lockup: text-only wordmark (no mark).
 * variant: "dark" = Ink wordmark (Paper/light bg); "light" = Paper wordmark (Console/dark bg)
 */
export default function BrandLockup({
  to = '/dashboard',
  collapsed = false,
  variant = 'dark',
  className,
  asLink = true,
}) {
  const wordmarkClass = variant === 'light' ? 'text-paper' : 'text-ink';

  const content = collapsed ? (
    <span className={cn('text-[15px] font-semibold tracking-[-0.02em] leading-none', wordmarkClass)}>Inter</span>
  ) : (
    <span className={cn('flex flex-col leading-none text-left', wordmarkClass)}>
      <span className="text-[15px] font-semibold tracking-[-0.02em]">Inter</span>
      <span className="text-[11px] font-semibold mt-0.5 text-mute">Labs</span>
    </span>
  );

  if (!asLink) {
    return (
      <span className={cn('inline-flex items-center', className)} aria-label="Inter Labs">
        {content}
      </span>
    );
  }

  return (
    <Link to={to} className={cn('inline-flex items-center no-underline', className)} aria-label="Inter Labs">
      {content}
    </Link>
  );
}
